import { Dialog, DialogContent } from '@mui/material';

import { useDispatch } from 'react-redux';

// Dostosuj ścieżkę do miejsca,
// w którym znajduje się BeerForm.
import BeerForm from '../../../common/BeerForm/BeerForm';

// Podmień nazwę akcji, jeśli w productsRedux
// używasz innej nazwy.
import { addBeerRequest } from '../../../../redux/beersRedux';

export default function AddMissingProductDialog({
  open,
  product,
  onClose,
  onSaved,
}) {
  const dispatch = useDispatch();

  const handleAddProduct = async (productData) => {
    const result = await dispatch(addBeerRequest(productData));

    /*
     * Gdy thunk nie rzuca błędu dla odpowiedzi
     * HTTP 4xx/5xx, sprawdź tutaj jego format
     * i w razie potrzeby rzuć wyjątek.
     */

    await onSaved?.(result?.data ?? result);
  };

  const handleClose = (_event, reason) => {
    if (reason === 'backdropClick') {
      return;
    }

    onClose?.();
  };

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="md">
      <DialogContent
        sx={{
          p: {
            xs: 2,
            md: 3,
          },
        }}
      >
        {product && (
          <BeerForm
            key={product.materialNumber}
            props={{
              materialNumber: product.materialNumber,

              description: product.description,

              /*
               * Pozostałe wartości użytkownik
               * uzupełnia w formularzu.
               */
              brand: null,
              package: null,
              shelfLife: '',
              palletQty: '',
              casHL: '',
            }}
            action={handleAddProduct}
            actionText="Dodaj brakujący produkt"
            buttonText="Dodaj produkt i wznów analizę"
          />
        )}
      </DialogContent>
    </Dialog>
  );
}
